import axios from "axios";

export async function registerEmailInKlaviyo(email, language) {
  let qs = require('qs');
  let data = qs.stringify({
    'data': '{"token": "TN9Cge", "properties": {"$email": "' + email + '", "PreferredLanguage": "' + language + '"}}'
  });

  const config = {
    method: 'post',
    url: 'https://a.klaviyo.com/api/identify',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: data
  };

  axios(config)
    .catch(function (error) {
      console.log(error);
    });
}
